<template>
  <v-date-picker 
    v-model="calendar.date"
    @input="inputDate"
    :attributes="calendar.attrs"
    :input-props="{ 
      name: 'name',
      autocomplete: 'off'
    }">
    <input class="date-picker-input"
      @input="inputManual"
      :value="formatDate(calendar.date)"
    >
    <template slot="header-title" slot-scope="page">
      {{page.yearLabel}}年{{page.monthLabel}}
    </template>
    <template slot="header-left-button">
      <div class="arrow-button vc-flex vc-justify-center vc-items-center vc-cursor-pointer vc-select-none vc-pointer-events-auto hover:vc-opacity-50">
        <FontawesomeIcon :icon="['fa','angle-left']" class="icn" />
      </div>
    </template>
    <template slot="header-right-button">
      <div class="arrow-button vc-flex vc-justify-center vc-items-center vc-cursor-pointer vc-select-none vc-pointer-events-auto hover:vc-opacity-50">
        <FontawesomeIcon :icon="['fa','angle-right']" class="icn" />
      </div>
    </template>
  </v-date-picker>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted, watch } from '@vue/composition-api'
import moment from 'moment'
import * as _ from 'lodash'
import { formatDate } from '@/util/common'

export default defineComponent({
  neme: 'PCKnowledgeCalendar',
  props: {
    type: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const { type } = props
    const store = context.root.$store
    const { knowledge } = store.state
    
    const calendar = reactive({
      attrs: [
        {
          mode: 'single',
          highlight: true
        }
      ],
      date: ''
    })

    // ストアの変更を検知する
    watch(() => knowledge.search.search_date_start, (newVal, oldVal) => {
      if (props.type === 'start') {
        calendar.date = newVal ? newVal.replaceAll('/', '-') : newVal
      }
    })

    watch(() => knowledge.search.search_date_end, (newVal, oldVal) => {
      if (props.type === 'end') {
        calendar.date = newVal ? newVal.replaceAll('/', '-') : newVal
      }
    })
    const clearSelectedDate = () => {
      calendar.date = ''
    }
    const close = () => {
      context.emit('closeCalendar')
    }
    const inputDate = () => {
      moment(calendar.date).isValid() && 
        context.emit('submitCalendar', formatDate(calendar.date))
    }

    const inputManual = (e) => {
      const { target: { value } } = e
      if (value === '' || (moment(value).isValid() && value.match(/([0-9]{4})\/([0-9]{2})\/([0-9]{2})/) !== null)) {
        calendar.date = value
        context.emit('submitCalendar', formatDate(value))
      }
    }

    return {
      formatDate,
      calendar,
      clearSelectedDate,
      close,
      inputDate,
      inputManual
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  margin-bottom: 0;
}
.popup-container {
  transform: none;
  left: 80px;
  top: 35%;
  width: 460px;
}
.popup-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  .vc-container {
    margin: auto;
  }
  .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
  .btn {
    font-size: 1.4rem;
  }
  ::v-deep .vc-day {
    color: #005BAC;
  }
}
.date-picker-input {
  background-color: transparent;
  color: #fff;
  border: 1px solid rgba(255,255,255,.8);
  border-radius: 4px;
  display: block;
  height: 48px;
  width: 100%;
  max-width: 138px;
  padding: 4px 10px;
  &::placeholder {
    color: rgba(255,255,255,.1);
  }
}
.calendar-yearly-navi {
  list-style: none;
  margin-bottom: 20px;
  li {
    color: $color-link;
    font-size: 1.4rem;
    display: inline-block;
    vertical-align: middle;
    padding: 0 10px;
    @include hoverOpacity;
    .icn {
      margin: 0 5px;
    }
    & + li {
      border-left: 1px solid $color-line;
    }
  }
}
.vc-arrows-container {
  .arrow-button {
    width: 48px;
    height: 32px;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: #005BAC;
  }
}
.list-result {
  &-item {
    &-sub {
      width: 48px;
      margin-left: 20px;
    }
  }
}
</style>
